/** Display labels for monthly payroll run types (values match API `run_type`). */

export const PAYROLL_RUN_TYPE_LABELS = {
  regular: "Standard Monthly Payroll",
  advance: "Mid-Month Advance (full recovery same month)",
  final: "Month-End Final Payroll",
};

export const PAYROLL_RUN_TYPE_OPTIONS = [
  { value: "regular", label: PAYROLL_RUN_TYPE_LABELS.regular },
  { value: "advance", label: PAYROLL_RUN_TYPE_LABELS.advance },
  { value: "final", label: PAYROLL_RUN_TYPE_LABELS.final },
];

export function getPayrollRunTypeLabel(type) {
  return PAYROLL_RUN_TYPE_LABELS[type] || type || "";
}

/** API `period_code` for monthly runs (matches PayrollPeriodService). */
export function buildMonthlyPeriodCode(periodYm, runType = "regular") {
  const ym = String(periodYm || "").trim();
  if (!/^\d{4}-\d{2}$/.test(ym)) return "";
  const rt = String(runType || "regular").toLowerCase();
  if (rt === "advance") return `${ym}:advance`;
  if (rt === "final") return `${ym}:final`;
  return ym;
}
